/* eslint-disable react/prop-types */
import React from 'react';
import PermissaoForm from './PermissaoForm';
import { Container } from './styles';

function Card({ setForm, form }) {
  return (
    <Container>
      <h1>Permissões grupo</h1>
      <PermissaoForm setForm={setForm} form={form} />
    </Container>
  );
}

export default Card;
